import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Sparkles, ArrowRight, Check } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const CTASection = () => {
  const { user, subscription } = useAuth();
  const navigate = useNavigate();
  const isPremium = subscription?.subscribed;

  const handleStartTrial = () => {
    if (user) {
      navigate('/pricing');
    } else {
      navigate('/auth');
    }
  };

  const benefits = [
    "7-Day Free Trial — No Credit Card",
    "Access to Elite Trading Signals",
    "Real-Time Signal Notifications",
    "Dashboard v1.0 Analytics",
    "24/7 Community Support",
    "Cancel Anytime"
  ];

  return (
    <section className="py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-opal opacity-10" />
      <div className="container px-4 relative z-10">
        {!isPremium && (
          <Card className="p-8 md:p-16 bg-gradient-primary relative overflow-hidden max-w-5xl mx-auto">
            <div className="absolute inset-0 bg-card/85 backdrop-blur-2xl" />
            <div className="relative z-10 text-center space-y-8">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/20 rounded-full mb-4">
                <Sparkles className="w-4 h-4 text-primary animate-pulse" />
                <span className="text-sm font-bold">Limited Time Offer</span>
              </div>
            
            <h2 className="text-4xl md:text-5xl font-bold">
              Start Trading Like the <span className="bg-gradient-primary bg-clip-text text-transparent">Top 1%</span> Today
            </h2>
            
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Get elite crypto signals from multiple professional traders — all unified in one powerful platform
            </p>

            <div className="grid md:grid-cols-2 gap-4 max-w-2xl mx-auto pt-6">
              {benefits.map((benefit, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-3 p-3 rounded-lg bg-secondary/20 backdrop-blur-sm text-left"
                >
                  <Check className="w-5 h-5 text-primary flex-shrink-0" />
                  <span className="text-sm font-medium">{benefit}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
              <Button 
                size="lg" 
                className="bg-gradient-primary hover:shadow-glow-primary transition-all duration-300 text-lg px-12 py-6 group"
                onClick={handleStartTrial}
              >
                <Sparkles className="w-5 h-5 group-hover:rotate-12 transition-transform" />
                {user ? "Get Premium — Start Free Trial" : "Sign Up — Start Free Trial"}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
              
              <Button 
                size="lg" 
                variant="outline"
                className="text-lg px-12 py-6 border-primary/50 hover:bg-primary/10"
                asChild
              >
                <a href="/community" className="flex items-center gap-2">
                  Join Free Community
                </a>
              </Button>
            </div>

            <div className="pt-6 space-y-2">
              <p className="text-sm text-muted-foreground">
                💎 <span className="font-semibold">Normally $500-600/month</span> for multiple traders
              </p>
              <p className="text-2xl font-bold text-primary">
                Now just $99/month — All-in-One Platform
              </p>
            </div>
            </div>
          </Card>
        )}
      </div>
    </section>
  );
};

export default CTASection;
